import PropTypes from 'prop-types'
import React from 'react'
import ReactModal from 'react-modal'

import Button from 'components/Button'

import classes from './Modal.scss'

export const Modal = (props) => <ReactModal
  className={classes.modal}
  overlayClassName={classes.overlay}
  {...props}
>
  <div className={classes.inner}>
    {props.title && <h2 className={classes.title}>{props.title}</h2>}
    {props.description && <p className={classes.description}>{props.description}</p>}

    {props.children}

    {!!props.buttons.length && <div className={classes.buttons}>
      {props.buttons.map((o, i) => {
        return <Button {...o} key={`button-${i}`}>{o.text}</Button>
      })}
    </div>}
  </div>
</ReactModal>

Modal.propTypes = {
  title: PropTypes.string,
  description: PropTypes.node,
  buttons: PropTypes.array,
  children: PropTypes.node
}

Modal.defaultProps = {
  buttons: []
}

export default Modal



// WEBPACK FOOTER //
// ./src/components/Modal/Modal.js